module.exports = __webpack_public_path__ + "img/22.6ab05b01.jpg";